var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicantsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.664 12.0002V1.3335H24L28.6667 6.00016V30.6668H19.3333M22 1.3335V8.00016H28.6667M8.66667 22.6668C8.14138 22.6668 7.62123 22.5634 7.13593 22.3623C6.65063 22.1613 6.20967 21.8667 5.83824 21.4953C5.46681 21.1238 5.17217 20.6829 4.97115 20.1976C4.77013 19.7123 4.66667 19.1921 4.66667 18.6668C4.66667 18.1415 4.77013 17.6214 4.97115 17.1361C5.17217 16.6508 5.46681 16.2098 5.83824 15.8384C6.20967 15.467 6.65063 15.1723 7.13593 14.9713C7.62123 14.7703 8.14138 14.6668 8.66667 14.6668C9.72753 14.6668 10.7449 15.0883 11.4951 15.8384C12.2452 16.5885 12.6667 17.606 12.6667 18.6668C12.6667 19.7277 12.2452 20.7451 11.4951 21.4953C10.7449 22.2454 9.72753 22.6668 8.66667 22.6668ZM8.66667 22.6668C6 22.6668 2 24.0002 2 29.3335V30.6668H15.3333V29.3335C15.3333 24.0002 11.3333 22.6668 8.66667 22.6668Z",
    stroke: "#008A61",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantsIcon);
export default __webpack_public_path__ + "static/media/applicants_icon.bdd9b85613e810931f77a35967b906fd.svg";
export { ForwardRef as ReactComponent };